// @flow
import React, { type Element } from 'react';

const PhishingCreate = (): Element<*> => {
  return <div />;
};

export default PhishingCreate;
